import Alert from "@shared/v2/Alert";
import { CircleCheckSolidV6 } from "@shared/v2/Icomoon";

// The card the transaction keeps once someone closes the order in Blueprint's portal. It draws no
// milestone ladder, no status rows and no timestamp: nothing about the order changes after this.
const CompleteStage = () => (
  <Alert
    variant="success"
    icon={<CircleCheckSolidV6 size="l" />}
    title="Closing Finalized!"
    text="Disbursement, recording, and policies issued. No further updates from Blueprint."
  />
);

export default CompleteStage;
